export const MOBILE_MID_BREAKPOINT: string = '(max-width: 767px)';
export const INBOX_URL: string = '/inbox/';
export const DEFAULT_CONCIERGE_NAME = 'Darcy';
export const CONCIERGE_IMAGE_URL = 'https://images-cdn.easyweddings.com.au/s3/prod-ew-image-global-v2/Live/ImageUploader/original-crop-83906bd7-3b34-5777-1121-3c1f217e116a-184f8b8c-83c6-4e71-8ec7-e05a1d94af94.jpg?quality=80&format=jpg&mode=crop&autorotate=true&width=250&height=250';
export const MAX_CONTENT_WIDTH = 936;
export const SLIDER_GAP = 24;
export const CART_COOKIE_NAME = 'PackageVwpCartHash';
export const CART_COOKIE_COUNT = 'PackageVwpCartCount';
export const VWP_COOKIE_REGION = 'PackageVwpRegion';
export const THREE_MONTH_IN_SECONDS = 60 * 60 * 24 * 30 * 3;
export const WEDPOINT_EARN_RATE = 0.8;
export const WEDPOINT_REDEEM_RATE = 8;
export const WEDPOINT_DEFAULT_BALANCE = 400;
export const PACKAGES_DEPOSIT = 99;
export const EVENT_OPEN_MESSAGING_DRAWER = 'openMessagingDrawer';
export const EVENT_LOGIN_COMPLETE = 'loginComplete';
export const IMAGE_SOURCES = [
    {
        media: '(max-width: 768px)',
        width: 720,
    },
    {
        media: '(max-width: 1320px)',
        width: 944,
    },
    {
        media: '(min-width: 1320px)',
        width: 498,
    }
];

export const NEW_USER_COOKIE = 'ewIsNewUser';
export const LOGIN_SESSION_COOKIE = 'EWLoginUserDetails';
export const USER_DISPLAY_NAME_COOKIE = 'ew_UserDisplayName';
export const USER_EMAIL_COOKIE = 'ew_UserEmail';
export const USER_LOCATION_COOKIE = 'ew_UserLocation';
export const USER_PHONE_COOKIE = 'ew_UserPhone';
export const USER_WEDDING_DATE_COOKIE = 'ew_UserWeddingDate';
export const USER_GUESTS_COOKIE = 'ew_UserWeddingGuests';
export const USER_VENUE_ID_COOKIE = 'ew_UserWeddingVenueId';
export const USER_VENUE_NAME_COOKIE = 'ew_UserWeddingVenueName';
